import React, { ReactNode } from 'react';
import { AppleIcon } from '@fiverr-private/icons';

import { SocialButton } from '../SocialButton';
import { translate } from '../../utils/translate';
import { SocialProvider } from '../SocialButton/constants';
import { AuthenticationResponse } from '../../shared/constants/authenticationFlow';

interface AppleButtonProps {
    children?: ReactNode;
    onSuccess?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onError?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onClick?: () => void;
}

export const AppleButton = ({
    children = translate('social_buttons.continue_with_apple'),
    onSuccess,
    onError,
    onClick,
}: AppleButtonProps) => (
    <SocialButton SocialIcon={AppleIcon} provider="apple" onSuccess={onSuccess} onError={onError} onClick={onClick}>
        {children}
    </SocialButton>
);
